import { openLottery, openPrize } from '@this/services/lottery';
import orderBy from 'lodash/orderBy';
import { Toast } from 'vant';
const state = {
  showPrize: false,
  bigPrize: false,
  lotteryResult: {},
  logosImg: [],
};

const mutations = {
  setShowPrize(state, bool) {
    state.showPrize = bool;
  },
  setBigPrize(state, bool) {
    state.bigPrize = bool;
  },
  setLotteryResult(state, obj) {
    state.lotteryResult = obj;
  },
  setLogos(state, array) {
    state.logosImg = array;
  },
};

const getters = {
  taskList(state) {
    const { allTaskList, showAllTask } = state;
    let taskList = orderBy(JSON.parse(JSON.stringify(allTaskList)), ['num'], ['desc']);
    if (!showAllTask) {
      taskList = taskList.splice(0, 1);
    }
    return taskList;
  },
};

const actions = {
  // 事件
  gameBox({ commit, rootState }) {
    const {
      user: { userInfo },
    } = rootState;
    let logos = userInfo.logos.logos;
    commit('setLogos', logos);
  },
  async clickLottery({ commit, dispatch, rootState }) {
    const { userInfo } = rootState.user;
    if (userInfo.chance < 1) {
      Toast('剩余0次开红包，完成任务增加红包次数');
      return;
    } else {
      await dispatch('openLottery');
      await dispatch('config/getPrizePicture', null, { root: true });
      dispatch('changeShowPrize');
      commit('user/calcUserChance', { type: 'minus' }, { root: true });
    }
  },
  async clickPrize({ dispatch }) {
    await dispatch('openPrize');
  },
  clickConfirm({ state, dispatch }) {
    const {
      lotteryResult: { category, link },
    } = state;
    if (category === 'link') {
      dispatch('goto/gotoLink', link, { root: true });
    }
  },
  // 步骤
  openLottery({ rootState, commit, dispatch }) {
    const { city } = rootState.city;
    openLottery({
      city: city.name,
    }).then((res) => {
      if (!res.code) {
        commit('setLotteryResult', res.data);
        if (res.data.category == 'card') {
          dispatch('logoInfo');
        }
      }
    });
  },
  openPrize({ commit, dispatch }) {
    openPrize().then((res) => {
      if (!res.code) {
        dispatch('config/getPrizePicture', null, { root: true });
        dispatch('changeBigrize');
        commit('user/setExchange', true, { root: true });
      }
    });
  },
  logoInfo({ state, commit, rootState, rootGetters }) {
    const {
      lotteryResult: { value },
    } = state;
    const brandList = rootGetters['config/brandList'];
    const currentBrand = brandList.find((item) => value == item.id);
    if (currentBrand) {
      state.lotteryResult.cardImg = currentBrand.brand_img;
    }
    const cards = rootState.user.cards;
    if (cards.length < 5) {
      cards.push(value);
      commit('user/setCards', cards, { root: true });
    }
  },
  changeShowPrize({ commit, state }, bool) {
    const showPrize = bool ?? !state.showPrize;
    commit('setShowPrize', showPrize);
  },
  changeBigrize({ commit, state }, bool) {
    const bigPrize = bool ?? !state.bigPrize;
    commit('setBigPrize', bigPrize);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
